import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import * as yup from "yup";

export const ResetSenhaSchema = yup.object().shape({
  email: yup
    .string()
    .required(mensagemDeErroPadrao("E-mail"))
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Digite um e-mail válido"),
});
